import React from 'react';

interface TimeCellProps {
    dayKey: string;
    time: string;
}

// Represents individual time cells in the grid.
export function TimeCell({ dayKey, time }: TimeCellProps) {
    return (
        <div
            id={`${dayKey}_${time}`}
            data-testid={`${dayKey}_${time}`}
            className="border-light-gray h-20 grow border-[0.5px] bg-gray-200 px-3"
        />
    );
}
